import { HammerGestureConfig } from '@angular/platform-browser';
import { DIRECTION_HORIZONTAL } from 'hammerjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HammerConfig extends HammerGestureConfig {
  overrides = <any>{
    swipe: { direction: DIRECTION_HORIZONTAL },
    pinch: { enable: false },
    rotate: { enable: false },
  };
}
